const routes = [{
  path: '/quote',
  component: () => import('@/views/quote'),
  name: 'quote',
  meta: {
    title: '报价配置管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/quote.js